
import { useContext, useMemo } from "react";
import Valve from "../components/Valve";
import Transmitter4 from "../components/Transmitter4";
import Transmitter from "../components/Transmitter";
import "./CrudeDehyd.css";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import { useState, useEffect } from "react";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";
import LevelTransmitterIndicator from "../components/LevelTransmitterIndicator";
import PumpFaceplate from "../components/PumpFaceplate";
import { PumpContext } from "../context/PumpContext";
import Pump from "../components/Pump";
import ElectrostaticGridTransformerSVG from "../components/ElectrostaticGridTransformerSVG";
import ElectrostacticGridTransformerFaceplate from "../components/ElectrostacticGridTransformerFaceplate";
import { TransformerContext } from "../context/TransformerContext"; 
import { trackPageVisit } from "../competency/PageTracker";


 
      /* ✅ CONTROL VALVE PERCENTAGE OUTPUT Indicator */
                function ValveOutput({ value, x, y, r=0 }) {
                return (
                  <div
                    style={{
                      position: "absolute",
                      left: x,
                      top: y,
                      color: "white",
                      fontSize: "10px",
                      padding: "2px 6px",
                      borderRadius: "4px",
                      transform: `rotate(${r}deg)`,
                      transformOrigin: "center",
                      cursor: "pointer"
                    }}
                  >
                    {value.toFixed(1)}
                  </div>
                );
              }


function CrudeDehyd() {

    useEffect(() => {
  
    trackPageVisit("CrudeDehyd");
  
  }, []);

const { valves, toggleValve, transmitters } = useContext(WellContext);
  


  const DEFAULT_VALVES = {
  FCV_18001: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_18002: { mode: "Manual", opening: 0, sp: "", pv: "" },

};

const [valveData, setValveData] = useState(() => {
  const saved = localStorage.getItem("CrudeDehyd_valveData");

  if (!saved) return DEFAULT_VALVES;

  try {
    const parsed = JSON.parse(saved);

    // ✅ Merge saved + default (CRITICAL)
    return {
      FCV_18001: { ...DEFAULT_VALVES.FCV_18001, ...parsed.FCV_18001 },
      FCV_18002: { ...DEFAULT_VALVES.FCV_18002, ...parsed.FCV_18002 },
    };

  } catch {
    return DEFAULT_VALVES;
  }
});



/* ✅ Persist */
  useEffect(() => {
    localStorage.setItem("CrudeDehyd_valveData", JSON.stringify(valveData));
  }, [valveData]);

  /* ================= ✅ FIXED UPDATE FUNCTION ================= */
  const updateValveData = (tag, field, value) => {
  setValveData(prev => ({
    ...prev,
    [tag]: {
      ...(prev[tag] || DEFAULT_VALVES[tag]),
      [field]: field === "opening" ? Number(value) || 0 : value
    }
  }));
};

  /* ================= PANEL CONTROL ================= */
  const [openPanels, setOpenPanels, setTransmitters] = useState([]);

  const openPanel = (tag) => {
    if (!openPanels.includes(tag)) {
      setOpenPanels(prev => [...prev, tag]);
    }
  };

  const closePanel = (tag) => {
    setOpenPanels(prev => prev.filter(p => p !== tag));
  };

 
 
  // ================= PUMP PANEL LOGIC =================

  const [openPumpPanels, setOpenPumpPanels] = useState([]);

const openPumpPanel = (tag) => {
  if (!openPumpPanels.includes(tag)) {
    setOpenPumpPanels(prev => [...prev, tag]);
  }
};

const closePumpPanel = (tag) => {
  setOpenPumpPanels(prev => prev.filter(p => p !== tag));
};





// ================= CONTEXT =================
const { pumpData } = useContext(PumpContext);

// ================= INPUTS =================
const suctionPressure = Number(transmitters?.PT_15007a ?? 0);
const suctionFlow = Number(transmitters?.FIC_15007 ?? 0);
const suctionTemp = Number(transmitters?.TT_15007a ?? 0);

// ================= VALVE =================
const valveOpeningRaw = Number(valveData?.FCV_18001?.opening ?? 0);

// Clamp 0–100
const valveOpening = Math.max(0, Math.min(100, valveOpeningRaw));

// ================= PUMP STATUS =================
const isPumpAOn = pumpData?.["P-101A"]?.running ?? false;
const isPumpBOn = pumpData?.["P-101B"]?.running ?? false;

const runningPumps = [isPumpAOn, isPumpBOn].filter(Boolean).length;

// ================= INTERLOCK =================
const pumpsAllowed = suctionFlow > 0 && runningPumps > 0;

// ================= TABLES =================
const flowTable = {
  0: 0, 10: 1.1, 20: 1.2, 30: 2.5, 40: 3,
  50: 4, 60: 4.3, 70: 5, 80: 5.5, 90: 6, 100: 7
};

const tempTable = {
  0: 5, 10: 1.3, 20: 1.1, 30: 1.08, 40: 1.075,
  50: 1.07, 60: 1.065, 70: 1.06, 80: 1.05, 90: 1.04, 100: 1.03
};

const pressureTable = {
  0: 7, 10: 1.9, 20: 1.6, 30: 1.2, 40: 1.15,
  50: 1.08, 60: 1.06, 70: 1.05, 80: 0.89, 90: 0.8, 100: 1.079
};

// ================= INTERPOLATION =================
const interpolate = (value, table) => {
  const keys = Object.keys(table).map(Number).sort((a, b) => a - b);

  if (table[value] !== undefined) return table[value];

  let lower = 0;
  let upper = 100;

  for (let i = 0; i < keys.length - 1; i++) {
    if (value >= keys[i] && value <= keys[i + 1]) {
      lower = keys[i];
      upper = keys[i + 1];
      break;
    }
  }

  const ratio = (value - lower) / (upper - lower);

  return table[lower] + ratio * (table[upper] - table[lower]);
};

// ================= MULTIPLIERS =================
const flowMultiplier = interpolate(valveOpening, flowTable);
const tempMultiplier = interpolate(valveOpening, tempTable);
const pressureMultiplier = interpolate(valveOpening, pressureTable);

// ================= FLOW =================
const FIC_18001 = pumpsAllowed
  ? suctionFlow * flowMultiplier
  : 0;

// ================= PRESSURE =================
const [PT_18002, setPT_18002] = useState(() => {
  const saved = localStorage.getItem("PT_18002");
  return saved !== null ? Number(saved) : 22;
});

useEffect(() => {
  const interval = setInterval(() => {
    setPT_18002(prev => {

      if (!pumpsAllowed) return 0;

      // EXACT BASE: 1.2 × multiplier
      const target = 1.2 * pressureMultiplier;

      return prev + (target - prev) * 0.15;
    });
  }, 200);

  return () => clearInterval(interval);
}, [pumpsAllowed, pressureMultiplier]);

// ================= TEMPERATURE =================
const [TT_18001, setTT_18001, pumpsRunning] = useState(() => {
  const saved = localStorage.getItem("TT_18001");
  return saved !== null ? Number(saved) : 22;
});

useEffect(() => {
  const interval = setInterval(() => {
    setTT_18001(prev => {

      if (!pumpsAllowed) return 0;

      const target = suctionTemp * tempMultiplier;

      return prev + (target - prev) * 0.15;
    });
  }, 200);

  return () => clearInterval(interval);
}, [pumpsAllowed, suctionTemp, tempMultiplier]);


      // ================= PUSH TO GLOBAL =================
      useEffect(() => {
                    localStorage.setItem("FIC_18001", FIC_18001);
                  }, [FIC_18001]);
      useEffect(() => {
                    localStorage.setItem("PT_18002", PT_18002);
                  }, [PT_18002]);
      useEffect(() => {
                    localStorage.setItem("TT_18001", TT_18001);
                  }, [TT_18001]);




  // ================= CRUDE DEHYDRATOR ELECTROSTATIC TRANSFORMER CODES =================
     


/* ================= CONTEXT ================= */
const { transformerData } = useContext(TransformerContext);

/* ================= UI STATE ================= */
const [showFaceplate, setShowFaceplate, transformerRunning, setTransformerRunning] = useState(false);

const isDV_18001Open = valves?.DV_18001 === false;


/*========================================================= */
const transformer = transformerData?.["TR-201"] ?? {};

/*
Expected faceplate values:
{
  running: true/false,
  maxTemp: 110
}
*/

const isRunning = transformer.running ?? false;

/* Max Temp entered from faceplate */
const TT_18002_SP = Number(transformer.maxTemp ?? 90);

/* =========================================================
   INLET CONDITIONS
========================================================= */

/* dynamic values from upstream */
const inletBSW = Number(transmitters?.inletBSW ?? 5.0);
const inletSalinity = Number(transmitters?.inletSalinity ?? 2400);


/* =========================================================
   TRANSFORMER TEMPERATURE OUTPUT
   TT_18002
========================================================= */

const [TT_18002, setTT_18002] = useState(() => {
  const saved = localStorage.getItem("TT_18002");
  return saved !== null ? Number(saved) : 22;
});

useEffect(() => {
  const timer = setInterval(() => {
    setTT_18002((prev) => {
      /* OFF = cool down gradually */
      if (!isRunning) {
        return Math.max(prev - 0.25, 22);
      }

      /* ON = heat up 0.25 every second */
      if (prev < TT_18002_SP) {
        return Math.min(prev + 0.25, TT_18002_SP);
      }

      return prev;
    });
  }, 1000);

  return () => clearInterval(timer);
}, [isRunning, TT_18002_SP]);

/* =========================================================
   OUTLET TEMP
========================================================= */

const TT_18003 = isDV_18001Open ? Number((TT_18002 * 0.96).toFixed(2)) : 22;

/* =========================================================
   TEMP FACTOR FOR PERFORMANCE
========================================================= */

const tempFactor =
  TT_18002_SP > 0
    ? Math.min(TT_18002 / TT_18002_SP, 1)
    : 0;

/* =========================================================
   DEHYDRATION PERFORMANCE
   Higher Temp = Better Results
========================================================= */

const isOutletFlowing =
  isRunning &&
  isDV_18001Open &&
  FIC_18001 > 0;

const finalBSW = isOutletFlowing && isRunning
  ? inletBSW * (1 - 0.92 * tempFactor)
  : inletBSW;

const finalSalinity = isOutletFlowing && isRunning
  ? inletSalinity * (1 - 0.88 * tempFactor)
  : inletSalinity;

/* Water removed */
const waterRemoved = Math.max(inletBSW - finalBSW, 0);

/* Efficiency */
const efficiency =
  inletBSW > 0
    ? ((inletBSW - finalBSW) / inletBSW) * 100
    : 0;

/* =========================================================
   OUTLET FLOW
========================================================= */
  const isDV_18002Open = valves?.DV_18002 ===false;


  const FIC_16001a = JSON.parse(
  localStorage.getItem("FIC_16001a") || "false"
);

const FIC_18002 = isDV_18001Open ? (50 - (66 * FIC_16001a)) : 0; 

useEffect(() => {
  localStorage.setItem(
    "FIC_18002",
    JSON.stringify(FIC_18002)
  );
}, [FIC_18002]);
/* =========================================================
   OPTIONAL SVG INTENSITY
========================================================= */

const intensity = Math.round(tempFactor * 100);

/* =========================================================
   PUSH TO GLOBAL TRANSMITTERS
========================================================= */

useEffect(() => {
  if (typeof setTransmitters !== "function") return;

  setTransmitters((prev) => ({
    ...prev,

    /* inlet tracking */
    inletBSW: Number(inletBSW.toFixed(2)),
    inletSalinity: Number(inletSalinity.toFixed(0)),

    /* transformer */
    TT_18002: Number(TT_18002.toFixed(2)),

    /* outlet */
    TT_18003: Number(TT_18003.toFixed(2)),
    FIC_18002: Number(FIC_18002.toFixed(2)),

    finalBSW: Number(finalBSW.toFixed(2)),
    finalSalinity: Number(finalSalinity.toFixed(0)),

    efficiency: Number(efficiency.toFixed(1)),
    waterRemoved: Number(waterRemoved.toFixed(2)),

    transformerIntensity: intensity,
  }));
}, [
  inletBSW,
  inletSalinity,
  TT_18002,
  TT_18003,
  FIC_18002,
  finalBSW,
  finalSalinity,
  efficiency,
  waterRemoved,
  intensity,
]);

/* =========================================================
   VALUES TO PASS TO FACEPLATE
========================================================= */

<ElectrostacticGridTransformerFaceplate
  tag="TR-201"

  running={isRunning}

  primaryVoltage_V={415}
  primaryCurrent_A={72}

  secondaryVoltage_kV={18 + tempFactor * 10}
  secondaryCurrent_mA={110 + tempFactor * 80}

  loadPercent={45 + tempFactor * 50}

  crudeFlowrate_m3h={FIC_18001}
  vesselPressure_MPa={PT_18002}

  waterCutIn_percent={inletBSW}
  waterCutOut_percent={finalBSW}

  windingTemp_C={TT_18002}
  oilTemp_C={TT_18003}

  onClose={() => setShowFaceplate(false)}
/>


const FIC_18004 = FIC_18001 * 0.05 * (valveData?.FCV_18001?.opening || 0)/100;
const PT_18004 = PT_18002 * (valveData?.FCV_18001?.opening || 0)/100;




useEffect(() => {
                    localStorage.setItem("inletBSW", inletBSW);
                  }, [inletBSW]);
useEffect(() => {
                    localStorage.setItem("finalBSW", finalBSW);
                  }, [finalBSW]);
useEffect(() => {
                    localStorage.setItem("TT_18002", TT_18002);
                  }, [TT_18002]);
useEffect(() => {
                    localStorage.setItem("TT_18003", TT_18003);
                  }, [TT_18003]);
useEffect(() => {
                    localStorage.setItem("inletSalinity", inletSalinity);
                  }, [inletSalinity]);
useEffect(() => {
                    localStorage.setItem("finalSalinity", finalSalinity);
                  }, [finalSalinity]);
useEffect(() => {
                    localStorage.setItem("TT_18003", TT_18003);
                  }, [TT_18003]);
useEffect(() => {
                    localStorage.setItem("efficiency", efficiency);
                  }, [efficiency]);

  const FIC_18003 = isDV_18002Open ? (70 * (valveData?.FCV_18002?.opening || 0))/100 : 0;
  const FIC_18003a = isRunning ? ((inletBSW-finalBSW)/100) * FIC_18001 : 0;

  const inflows = FIC_18003a;
  const outflows = FIC_18003;

  useEffect(() => {
                    localStorage.setItem("FIC_18003", FIC_18003);
                  }, [FIC_18003]);

    useEffect(() => {
                    localStorage.setItem("TT_18003", TT_18003);
                  }, [TT_18003]);

  useEffect(() => {
                    localStorage.setItem("FIC_18004", FIC_18004);
                  }, [FIC_18004]);







  return (
    <div className="CrudeDehyd-container">
      {/* TITLE */}
      <h2 style={{
        position: "absolute",
        top: "0px",
        left: "256px",
        color: "white",
        background: "rgb(28, 3, 250)",
        padding: "2px 275px"
      }}>
        CRUDE DEHYDRATION UNIT
      </h2>

      {/* =================SHUTDOWN VALVES ================= */}

      
      {/* DV-18001 */}
      <Valve
        className="DV-18001"
        tag="DV_18001"
        x={988}
        y={237}
        isClosed={valves.DV_18001}
        toggle={toggleValve}
        r={90}
      />

      {/* DV-18002 */}
      <Valve
        className="DV-18002"
        tag="DV_18002"
        x={665}
        y={447}
        isClosed={valves.DV_18002}
        toggle={toggleValve}
        r={90}
      />

      
      
        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-18002 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-18002"
          style={{ position: "absolute", left: 895, top: 602}}  onClick={() => openPanel("FCV_18002")}>
          
          <defs>
            <linearGradient id="metal_18002">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_18002)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_18002)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>



        {/* FCV-18001 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-18001"
          style={{ position: "absolute", left: 387, top: 146 }}  onClick={() => openPanel("FCV_18001")}>
          
          <defs>
            <linearGradient id="metal_18001">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_18001)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_18001)" stroke="#7f8c8d" strokeWidth="2" />

          </svg>

          
        
        {/* ================= CONTROL VALVE FACEPLATES ================= */}
          {openPanels.map((tag, index) => (
            <ControlValveControlPanel
              key={tag}
              tag={tag}
              data={valveData?.[tag] ?? DEFAULT_VALVES?.[tag]}
              update={updateValveData}
              close={() => closePanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}

          {/* ================= PUMPS CONTROL VALVE FACEPLATES ================= */}
          {openPumpPanels.map((tag, index) => (
            <PumpFaceplate
              key={tag}
              tag={tag}
              close={() => closePumpPanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}


          {/* ================= ELECTROSTATIC TRANSFORMER LINK TO FACEPLATES ================= */}
          {showFaceplate && (
            <ElectrostacticGridTransformerFaceplate
              tag="TR-201"

              status={transformerRunning ? "RUNNING" : "STOPPED"}

              secondaryVoltage_kV={22}

              onClose={() => setShowFaceplate(false)}

              // 👇 THIS IS THE KEY LINK
              onStart={() => setTransformerRunning(true)}
              onStop={() => setTransformerRunning(false)}
            />
          )}

          <ElectrostaticGridTransformerSVG
      /* TRANSFORMER */
      tx={766}
      ty={130}
      tWidth={34}
      tHeight={16}
      tRotation={0}

      /* LEFT ROD */
      leftX={750}
      leftY={130}
      leftWidth={5}
      leftHeight={200}
      leftRotation={90}

      /* RIGHT ROD */
      rightX={750}
      rightY={145}
      rightWidth={5}
      rightHeight={200}
      rightRotation={90}

      running={transformerRunning}
      onClick={() => setShowFaceplate(true)}
    />


          {/* ================= CONTROL VALVE OUTPUTS ================= */}

      <ValveOutput
        value={Number(valveData?.FCV_18002?.opening || 0)}
        x={914}
        y={648}
      />

      <ValveOutput
        value={Number(valveData?.FCV_18001?.opening || 0)}
        x={413}
        y={193}
      />


    <Transmitter
        tag="PT-18002"
        value={[PT_18002]}
        x={410}
        y={357}
        unit="MPa"
        max={2}
        HH={1.8}
        H={1.6}
        L={0.04}
        LL={0.01}
        c="lime"
        description="PRESSURE OF CRUDE AT THE DISCHARGE OF THE CRUDE DEHYDRATOR PUMPS"
      />

    <Transmitter
        tag="FIC_18001"
        value={[FIC_18001]}
        x={300}
        y={352}
        unit="BPM"
        max={70}
        HH={50}
        H={46}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF CRUDE AT THE DISCHARGE OF THE CRUDE DEHYDRATOR PUMPS"
      />


    <Transmitter
      tag="TT_18001"
      value={[TT_18001]}
      x={300}
      y={273}
      unit="°C"
      max={100}
      HH={90}
      H={80}
      L={20}
      LL={10}
      c="lime"
      description="TEMPERATURE OF CRUDE AT THE DISCHARGE OF CRUDE DEHYDRATOR PUMPS"
    />
 
      <Transmitter4
      value={suctionFlow}
      x={128}
      y={567}
      c="TRANSPARENT"
    />

    <Transmitter
        tag="PT-18001"
        value={[suctionPressure]}
        x={128}
        y={511}
        unit="MPa"
        max={2}
        HH={1.8}
        H={1.6}
        L={0.04}
        LL={0.01}
        c="lime"
        description="PRESSURE OF CRUDE FROM 3RD STAGE SEPARATOR TO DEHYDRATOR PUMPS"
      />

    <Transmitter
      tag="TT_18002"
      value={[TT_18002]}
      x={662}
      y={113}
      unit="°C"
      max={250}
      HH={230}
      H={220}
      L={20}
      LL={10}
      c="lime"
      description="TEMPERATURE OF ELECTROSTATIC GRID TRANSFORMER"
    />


    <Transmitter
        tag="FIC_18002"
        value={[FIC_18002]}
        x={1026}
        y={358}
        unit="BPM"
        max={70}
        HH={50}
        H={46}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF DEHYDRATED CRUDE AT THE DISCHARGE OF THE CRUDE DEHYDRATOR (ELECTROSTATIC HEATER) IN BARREL PER MINUTE"
      />

    <Transmitter
        tag="finalBSW"
        value={[finalBSW]}
        x={1029}
        y={387}
        unit="%"
        max={2}
        HH={1.5}
        H={0.8}
        L={0.1}
        LL={0.03}
        c="lime"
        description="CONTENT OF BASIC WATER & SEDIMENTS OF DEHYDRATED CRUDE AT THE DISCHARGE OF THE CRUDE DEHYDRATOR (ELECTROSTATIC HEATER)"
      />

    <Transmitter
        tag="finalSalinity"
        value={[finalSalinity]}
        x={1025}
        y={402}
        unit="mg/L"
        max={350}
        HH={300}
        H={286}
        L={5}
        LL={3}
        c="lime"
        description="SALT CONTENT OF DEHYDRATED CRUDE AT THE DISCHARGE OF THE CRUDE DEHYDRATOR (ELECTROSTATIC HEATER)"
      />

    <Transmitter
      tag="TT_18003"
      value={[TT_18003]}
      x={1032}
      y={462}
      unit="°C"
      max={40}
      HH={38}
      H={37}
      L={20}
      LL={10}
      c="lime"
      description="TEMPERATURE OF DEHYDRATED CRUDE AT THE DISCHARGE OF ELECTROSTATIC GRID TO EXPORT PUMPS"
    />

      <Transmitter4
      value={suctionTemp}
      x={128}
      y={587}
      c="transparent"
    />
  
    <Transmitter
        tag="inletBSW"
        value={[inletBSW]}
        x={310}
        y={384}
        unit="%"
        max={3500}
        HH={2800}
        H={2500}
        L={5}
        LL={3}
        c="lime"
        description="CONTENT OF BASIC WATER & SEDIMENTS IN CRUDE AT THE INLET OF THE CRUDE DEHYDRATOR (ELECTROSTATIC HEATER)"
      />

    <Transmitter
        tag="inletSalinity"
        value={[inletSalinity]}
        x={292}
        y={399}
        unit="mg/L"
        max={3500}
        HH={2800}
        H={2500}
        L={5}
        LL={3}
        c="lime"
        description="SALT CONTENT OF CRUDE AT THE INLET OF THE CRUDE DEHYDRATOR (ELECTROSTATIC HEATER)"
      />



    <Transmitter
        tag="FIC-18003"
        value={[FIC_18003]}
        x={705}
        y={537}
        unit="LPM"
        max={70}
        HH={50}
        H={46}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF DISCHARGE FLOW TO DV-18002 FOR WATER TO DE-OILER VESSEL"
      />

    <Transmitter
        tag="FIC-18003a"
        value={[FIC_18003a]}
        x={705}
        y={507}
        unit="LPM"
        max={200}
        HH={180}
        H={150}
        L={5}
        LL={3}
        c="transparent"
        description="FLOWRATE OF SUCTION FLOW TO DV-18002 FOR WATER TO DE-OILER VESSEL"
      />

    <Transmitter
        tag="FIC-18004"
        value={[FIC_18004]}
        x={1060}
        y={114}
        unit="SCF/S"
        max={50}
        HH={40}
        H={30}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF GAS FROM CRUDE ELECTROSTATIC HEATER TO FLARE HEADER"
      />

      <Transmitter
        tag="PT-18004"
        value={[PT_18004]}
        x={1164}
        y={114}
        unit="MPa"
        max={2}
        HH={1.8}
        H={1.6}
        L={0.04}
        LL={0.01}
        c="lime"
        description="PRESSURE OF GAS FROM CRUDE ELECTROSTATIC HEATER TO FLARE HEADER"
      />

      <Pump
      tag="P-101A"
      x={294}
      y={484}
      rpm={1800}
      bladeCount={pumpData?.["P-101A"]?.bladeCount || 3}
      size={pumpData?.["P-101A"]?.size || 37}
      onClick={openPumpPanel}
    />

    <Pump
      tag="P-101B"
      x={294}
      y={588}
      rpm={1800}
      bladeCount={pumpData?.["P-101B"]?.bladeCount || 3}
      size={pumpData?.["P-101B"]?.size || 37}
      onClick={openPumpPanel}
    />


    <LevelTransmitterIndicator
      tag="LT_18001"
      totalLevel={12000}
      inflows={[FIC_18001/20]}
      outflows={[FIC_18002]}
      responseFactor={0.05}
      columnX={828}
      columnY={155}
      columnWidth={30}
      columnHeight={170}
      textX={900}
      textY={205}
      showFlow={true}
    />
    <LevelTransmitterIndicator
      tag="LT_18002"
      totalLevel={12000}
      inflows={[FIC_18003a]}
      outflows={[FIC_18003]}
      responseFactor={0.05}
      columnX={658}
      columnY={270}
      columnWidth={30}
      columnHeight={140}
      textX={560}
      textY={345}
      showFlow={true}
    />

    

    </div>
  );
}

export default CrudeDehyd;